import { useState, useEffect } from 'react';

const useApiCall = (api, id = null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState(undefined);

  const fetchApi = id => {
    setIsLoading(true);
    api(id && id)
      .then(result => {
        const type = typeof result.data;
        let optionsData =
          type === 'object' ? result.data : result.data.map(data => data);
        setIsLoading(false);
        setFetchedData(optionsData);
      })
      .catch(err => {
        //eslint-disable-next-line
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // setFetchedData(id ? {} : null);
    fetchApi(id);
    // eslint-disable-next-line
  }, []);

  const loadData = id => {
    fetchApi(id);
  };

  return [isLoading, fetchedData, setFetchedData, loadData];
};

export default useApiCall;
